<template>
	
	<div id="map" class="position-relative" style="width: 100%; height: 600px">
		<div class="map_content position-absolute  flex-column align-items-start justify-content-between  d-flex"
		     :class="{'hide':hide}">
			<div class="img-container">
				<img class="map_content-img" :src="mapTargetData.img" alt="">
			</div>
			<div class="content-container d-flex align-items-center justify-content-start flex-grow-0">
				<div class="map_content-ttl">{{mapTargetData.ttl}}</div>
			</div>
			<div class="content-container d-flex flex-column align-items-start justify-content-between flex-grow-0">
				<div class="map_content-subttl">Количество объектов</div>
				<div class="content d-flex align-items-center justify-content-center">
					<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
						<path
							d="M29.7867 13.9195C29.7848 13.89 29.7833 13.86 29.7776 13.8314C29.7738 13.8105 29.7667 13.7914 29.7605 13.771C29.7534 13.7467 29.7481 13.7219 29.7381 13.6986C29.7295 13.6781 29.7181 13.6591 29.7081 13.6395C29.6976 13.6186 29.6872 13.5967 29.6743 13.5772C29.6629 13.5591 29.6481 13.5433 29.6353 13.5267C29.62 13.5072 29.6053 13.4872 29.5881 13.4695C29.5738 13.4548 29.5576 13.4429 29.5419 13.4295C29.5224 13.4129 29.5043 13.3952 29.4829 13.3805C29.4648 13.3681 29.4448 13.3586 29.4253 13.3476C29.4043 13.3357 29.3843 13.3229 29.3619 13.3133C29.3372 13.3029 29.311 13.2957 29.2848 13.2876C29.2672 13.2824 29.251 13.2748 29.2329 13.2705L15.7143 10.2633V1.12096C15.7143 0.726201 15.3943 0.406677 15 0.406677H0.922873C0.528111 0.406677 0.208588 0.726201 0.208588 1.12096V28.8791C0.208588 29.2733 0.528111 29.5933 0.922873 29.5933H15H29.0776C29.4719 29.5933 29.7919 29.2733 29.7919 28.8791V13.9681C29.7919 13.9514 29.7881 13.9362 29.7867 13.9195ZM1.63716 1.83525H14.2857V10.8243C14.2857 10.8248 14.2857 10.8252 14.2857 10.8257V10.8362V28.1648H11.4843V21.6091C11.4843 21.2148 11.1648 20.8948 10.77 20.8948H5.1524C4.75764 20.8948 4.43811 21.2148 4.43811 21.6091V28.1652H1.63716V1.83525ZM10.0557 28.1648H5.86668V22.3233H10.0557V28.1648ZM24.7167 28.1648H22.7529V22.3233H24.7167V28.1648ZM21.3243 28.1648H19.3605V22.3233H21.3243V28.1648ZM26.1453 28.1648V21.6091C26.1453 21.2148 25.8253 20.8948 25.431 20.8948H18.6462C18.2519 20.8948 17.9319 21.2148 17.9319 21.6091V28.1652H15.7143V11.7272L28.3633 14.5414V28.1652H26.1453V28.1648Z"
							fill="black"/>
						<path
							d="M3.20284 7.71762H6.57379C6.96856 7.71762 7.28808 7.39809 7.28808 7.00333V3.63238C7.28808 3.23761 6.96856 2.91809 6.57379 2.91809H3.20284C2.80808 2.91809 2.48856 3.23761 2.48856 3.63238V7.00333C2.48856 7.39762 2.80808 7.71762 3.20284 7.71762ZM3.91713 4.34666H5.85951V6.28904H3.91713V4.34666Z"
							fill="black"/>
						<path
							d="M9.34908 7.71762H12.72C13.1148 7.71762 13.4343 7.39809 13.4343 7.00333V3.63238C13.4343 3.23761 13.1148 2.91809 12.72 2.91809H9.34908C8.95432 2.91809 8.6348 3.23761 8.6348 3.63238V7.00333C8.6348 7.39762 8.9548 7.71762 9.34908 7.71762ZM10.0634 4.34666H12.0057V6.28904H10.0634V4.34666Z"
							fill="black"/>
						<path
							d="M6.57332 19.7462C6.96808 19.7462 7.2876 19.4262 7.2876 19.0319V15.6614C7.2876 15.2671 6.96808 14.9471 6.57332 14.9471H3.20284C2.80808 14.9471 2.48856 15.2671 2.48856 15.6614V19.0319C2.48856 19.4262 2.80808 19.7462 3.20284 19.7462H6.57332ZM3.91713 16.3757H5.85951V18.3176H3.91713V16.3757Z"
							fill="black"/>
						<path
							d="M9.34908 19.7462H12.72C13.1148 19.7462 13.4343 19.4262 13.4343 19.0319V15.6614C13.4343 15.2671 13.1148 14.9471 12.72 14.9471H9.34908C8.95432 14.9471 8.6348 15.2671 8.6348 15.6614V19.0319C8.6348 19.4262 8.9548 19.7462 9.34908 19.7462ZM10.0634 16.3757H12.0057V18.3176H10.0634V16.3757Z"
							fill="black"/>
						<path
							d="M3.20284 13.7314H6.57379C6.96856 13.7314 7.28808 13.4119 7.28808 13.0171V9.64617C7.28808 9.25141 6.96856 8.93188 6.57379 8.93188H3.20284C2.80808 8.93188 2.48856 9.25141 2.48856 9.64617V13.0171C2.48856 13.4119 2.80808 13.7314 3.20284 13.7314ZM3.91713 10.3609H5.85951V12.3033H3.91713V10.3609Z"
							fill="black"/>
						<path
							d="M9.34908 13.7314H12.72C13.1148 13.7314 13.4343 13.4119 13.4343 13.0171V9.64617C13.4343 9.25141 13.1148 8.93188 12.72 8.93188H9.34908C8.95432 8.93188 8.6348 9.25141 8.6348 9.64617V13.0171C8.6348 13.4119 8.9548 13.7314 9.34908 13.7314ZM10.0634 10.3609H12.0057V12.3033H10.0634V10.3609Z"
							fill="black"/>
						<path
							d="M20.6505 15.0529H17.28C16.8857 15.0529 16.5657 15.3729 16.5657 15.7671V19.1376C16.5657 19.5319 16.8857 19.8519 17.28 19.8519H20.6505C21.0448 19.8519 21.3648 19.5319 21.3648 19.1376V15.7671C21.3648 15.3729 21.0448 15.0529 20.6505 15.0529ZM19.9362 18.4233H17.9943V16.4814H19.9362V18.4233Z"
							fill="black"/>
						<path
							d="M26.7971 15.0529H23.4266C23.0323 15.0529 22.7123 15.3729 22.7123 15.7671V19.1376C22.7123 19.5319 23.0323 19.8519 23.4266 19.8519H26.7971C27.1914 19.8519 27.5114 19.5319 27.5114 19.1376V15.7671C27.5114 15.3729 27.1919 15.0529 26.7971 15.0529ZM26.0828 18.4233H24.1409V16.4814H26.0828V18.4233Z"
							fill="black"/>
					</svg>
					{{mapTargetData.obg}}
				</div>
			</div>
			<div
				class="content-container content-container-link d-flex align-items-center justify-content-center align-self-stretch ">
<!--				<a :href="mapTargetData.link" class="map_content-link">-->
<!--					Перейти-->
<!--					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">-->
<!--						<path d="M2 11V9H14L10 5L11 3L18 10L11 17L10 15L14 11H2Z" fill="#B33031"/>-->
<!--					</svg>-->
<!--				</a>-->
				<router-link class="map_content-link"
				             :to="{path: '/objects/', query:{city: mapTargetData.ttl ,serv: 'Монтаж'}}"
				             tag="a"
				>
					Перейти
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
						<path d="M2 11V9H14L10 5L11 3L18 10L11 17L10 15L14 11H2Z" fill="#B33031"/>
					</svg>
				</router-link>
			</div>
			<a class="map_content-close" href="#" @click.prevent="hide = true">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
					<circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
					<path
						d="M20 6.30419L18.6958 5L12.5 11.1958L6.30419 5L5 6.30419L11.1958 12.5L5 18.6958L6.30419 20L12.5 13.8042L18.6958 20L20 18.6958L13.8042 12.5L20 6.30419Z"
						fill="#C5C5C5"/>
				</svg>
			</a>
		</div>
	</div>
</template>

<script>
	const axios = require('axios')
	export default {
		data () {
			return {
				points: [],
				placemarkimg: require('@/assets/img/placemark.svg'),
				placemarkimghover: require('@/assets/img/placemark2.svg'),
				
				stop: false,
				hide: true,
				data: null,
				mapTargetData: {
					ttl: null,
					img: null,
					obg: null,
					link: null,
				}
			}
		},
		mounted () {
			axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=map`,
				{responseType: 'json'}
			).then(({data}) => {
				this.points = data.addons.cityes
			}).then(() => {
				this.renderMap()
			})
			
		},
		methods: {
			renderMap () {
				const $this = this
				
				let placemarkimg = this.placemarkimg,
					placemarkimghover = this.placemarkimghover,
					points = this.points
				ymaps.ready(init)
				
				function init () {
					var myMap = new ymaps.Map('map', {
						center: [58.242688, 68.271599],
						zoom: 5,
						controls: []
					})
					let MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
						'<div class="map_placemark-con" style="color: #FFFFFF; font-weight: bold; width: 42px; height: 42px;">$[properties.iconContent]</div>'
					)
					let myCollection = new ymaps.GeoObjectCollection({}, {
						iconLayout: 'default#imageWithContent',
						iconImageHref: placemarkimg,
						iconImageSize: [50, 60],
						iconImageOffset: [-25, -60],
						iconContentOffset: [4, 4],
						iconContentLayout: MyIconContentLayout
					})
					
					points.forEach(function (point) {
						let coordinates = JSON.parse(point.coords),
							properties = {
								ttl: point.title,
								img: point.img.url,
								obg: point.text,
								link: point.link,
							},
							options = {},
							placemark = new ymaps.Placemark(coordinates, properties, options)
						myCollection.add(placemark)
						placemark.events
							.add('click', onClick)
							.add('mouseenter', function (e) {
								// Ссылку на объект, вызвавший событие,
								// можно получить из поля 'target'.
								e.get('target').options.set('iconImageHref', placemarkimghover)
							})
							.add('mouseleave', function (e) {
								e.get('target').options.unset('iconImageHref', placemarkimg)
							})
					})
					
					function onClick (e) {
						if (!$this.stop) {
							$this.stop = true
							var placemark = e.get('target'),
								map = placemark.getMap(),
								bounds = map.getBounds()
							
							$this.hide = true
							setTimeout(function () {
								$this.mapTargetData.ttl = placemark.properties.get('ttl')
								$this.mapTargetData.img = placemark.properties.get('img')
								$this.mapTargetData.obg = placemark.properties.get('obg')
								$this.mapTargetData.link = placemark.properties.get('link')
								setTimeout(function () {
									$this.hide = false
								}, 500)
								$this.stop = false
							}, 250)
						}
					}
					
					myMap.geoObjects
						.add(myCollection)
					
				}
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	[class*="ymaps-2"][class*="-ground-pane"] {
		filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale");
		/* Firefox 3.5+ */
		-webkit-filter: grayscale(100%);
		/* Chrome 19+ & Safari 6+ */
	}
	
	#map {
		overflow: hidden;
		box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
		border-radius: 6px;
		max-width: none;
		height: 590px;
		@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
			max-height: 540px;
		}
	}
	
	.map {
		background: #EAF5F4;
		
		&_placemark-con {
			border-radius: 100%;
		}
		
		&_placemark-img {
			border-radius: 100%;
			
		}
		
		&_content {
			top: 0px;
			left: 0px;
			bottom: 0px;
			z-index: 50;
			background: #FFFFFFf0;
			//opacity: 0.9;
			box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.08), 2px 0px 1px rgba(0, 0, 0, 0.05);
			border-radius: 6px;
			height: 100%;
			width: 100%;
			max-width: 256px;
			transition: all .25s ease-in-out;
			
			&.hide {
				transform: translateX(-100%);
			}
			
			.img-container {
				width: 100%;
				height: 190px;
				
				img {
					border-radius: 3px;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			
			.content-container {
				height: 95px;
				flex-grow: 2;
				flex-shrink: 0;
				width: 100%;
				border-bottom: 1px solid #EFEFEF;
				padding: 15px 30px;
				
				&-link {
					
					flex-grow: 1;
					flex-shrink: 1;
				}
				
				.map_content-ttl {
					font-weight: 500;
					font-size: 18px;
				}
				
				.map_content-subttl {
					font-weight: bold;
					font-size: 12px;
					color: #979797;
					text-transform: uppercase;
				}
				
				.content {
					font-weight: 500;
					font-size: 32px;
					line-height: 100%;
					
					svg {
						margin-right: 20px;
					}
				}
			}
			
			&-link {
				font-weight: 600;
				font-size: 20px;
				line-height: 24px;
				color: $activeColor;
				
				display: flex;
				align-items: center;
				justify-content: center;
				width: 225px;
				height: 50px;
				border: 1px solid $activeColor;
				box-sizing: border-box;
				border-radius: 6px;
				
				transition: all .3s ease-in-out;
				
				svg {
					transition: all .3s ease-in-out;
					margin-top: 2px;
					margin-left: 10px;
					
					path {
						transition: all .3s ease-in-out;
					}
				}
				
				&:hover {
					background-color: $activeColor;
					color: $defaultColor;
					
					svg {
						transform: translateX(100%);
						
						path {
							fill: $defaultColor;
						}
					}
				}
				
			}
			
			&-close {
				position: absolute;
				top: 10px;
				right: 10px;
				padding: 0;
				background-color: transparent;
				border: none;
				border-radius: 100%;
				box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.25);
				
			}
		}
	}
</style>